module.exports = __webpack_public_path__ + "img/7a8c6d6e-e953-4391-a732-a4f8cfb0abcf.2978a1f7.webp";